import { render, staticRenderFns } from "./detailHours.vue?vue&type=template&id=49a85522&scoped=true&"
import script from "./detailHours.vue?vue&type=script&lang=js&"
export * from "./detailHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a85522",
  null
  
)

export default component.exports